export default "__VITE_ASSET__DwAsC8JS__"